export const roles = {
  DashboardView: ['ADMIN', 'OPERATOR', 'SUPPORT'],
  JobListView: ['ADMIN', 'OPERATOR'],
  AdminJobsView: ['ADMIN', 'OPERATOR'],
  RetiredJobsView: ['ADMIN', 'OPERATOR'],
  WeekJobExecutionsList: ['ADMIN', 'OPERATOR', 'SUPPORT'],
  AllTimeJobExecutionsList: ['ADMIN', 'OPERATOR', 'SUPPORT'],
  JobExecutionDetailView: ['ADMIN', 'OPERATOR', 'SUPPORT'],
  IntegrationListView: ['ADMIN', 'OPERATOR'],
  FailedEmailListView: ['ADMIN', 'OPERATOR'],
  ReportListView: ['ADMIN', 'OPERATOR'],
  AnalyticsViews: ['ADMIN', 'OPERATOR'],
};
